<div class="alert-container">
  <div class="alert-list">
    @for (alert of alerts(); track alert.id) {
      <app-alert @alert [type]="alert.type" [id]="alert.id">{{ alert.message }}</app-alert>
    }
  </div>
</div>

@if (isLoading()) {
  <div class="spinner" @fade>
    @defer (on timer(500)) {
      <app-global-spinner></app-global-spinner>
    }
  </div>
}
<router-outlet />
